import script from "./userList.vue?vue&type=script&setup=true&lang=js"
export * from "./userList.vue?vue&type=script&setup=true&lang=js"

import "./userList.vue?vue&type=style&index=0&id=70288aee&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70288aee"]])

export default __exports__